

import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'customNumber' })
export class CustomNumberPipe implements PipeTransform {
  
  transform( value: number | string, format : string | null | undefined): string {
    return this.formatNumber(Number(value), format);
  }

  private formatNumber(value: number, format: string | null | undefined): string {
    let formattedValue : string = value.toFixed(2);
    if(format == null || !format || format.indexOf('#') == -1) return formattedValue;
    
    let _format = format.trim();
    let _sigle = _format.endsWith('0') || _format.endsWith('#') ? '' : this.recupererDerniersCaracteres(_format);
    _format = _format.replaceAll(_sigle, '').trim();
    _format = _format.replace(/[\u00a0]/g, ' ');
    let _thousandSeparator = '';
    let _spaceIndex = _format.indexOf(' '); let _commaIndex = _format.indexOf(','); let _dotIndex = _format.indexOf('.');
    if(_spaceIndex > - 1){ _thousandSeparator = ' '; }
    else if (_commaIndex > - 1 && _dotIndex > -1) { _thousandSeparator = _commaIndex < _dotIndex ? ',' : '.'; }
    else { _thousandSeparator = ''; }
    let _decimalSeparator = '';
    if(_dotIndex > - 1 && _commaIndex == - 1) { _decimalSeparator = '.'; }
    else if (_dotIndex == -1 && _commaIndex > - 1) { _decimalSeparator = ','; }
    else { _decimalSeparator = ''; }
    let _nbDecimales = _decimalSeparator != '' ? this.recupererPartieDecimale(_format, _decimalSeparator).length : 0;
    const tmpNumberFormat = new Intl.NumberFormat('en-US', { minimumFractionDigits: _nbDecimales, maximumFractionDigits: _nbDecimales, useGrouping : true });
    let tmpFormattedNumber = tmpNumberFormat.format(value);
    formattedValue = tmpFormattedNumber.replace(/[,.]/g, (match) => { return match === ',' ? _thousandSeparator : _decimalSeparator; });
    return formattedValue + _sigle;
  }

  private recupererDerniersCaracteres(chaine: string): string {
    let result = '';
    let stop = false;
    for (let i = chaine.length - 1; i >= 0; i--) {
      if (stop) { break; }
      const char = chaine[i];
      if (char === '#' || char === '0') { stop = true; }
      else { result = char + result; }
    }
    return result;
  }

  private recupererPartieDecimale(format: string, separateur: string = '.'): string {
    const indexSeparateur = format.indexOf(separateur);
  
    if (indexSeparateur !== -1) {
      // Récupérer la partie décimale à partir de l'index du séparateur
      const partieDecimale = format.substring(indexSeparateur + 1);
      return partieDecimale;
    } else {
      // Si le séparateur n'est pas trouvé, retourner une chaîne vide
      return '';
    }
  }

  public recupererNombreDecimales(format : string){
    let _format = format.trim();
    let _sigle = _format.endsWith('0') || _format.endsWith('#') ? '' : this.recupererDerniersCaracteres(_format);
    _format = _format.replaceAll(_sigle, '').trim();
    _format = _format.replace(/[\u00a0]/g, ' ');
    let _thousandSeparator = '';
    let _spaceIndex = _format.indexOf(' '); let _commaIndex = _format.indexOf(','); let _dotIndex = _format.indexOf('.');
    if(_spaceIndex > - 1){ _thousandSeparator = ' '; }
    else if (_commaIndex > - 1 && _dotIndex > -1) { _thousandSeparator = _commaIndex < _dotIndex ? ',' : '.'; }
    else { _thousandSeparator = ''; }
    let _decimalSeparator = '';
    if(_dotIndex > - 1 && _commaIndex == - 1) { _decimalSeparator = '.'; }
    else if (_dotIndex == -1 && _commaIndex > - 1) { _decimalSeparator = ','; }
    else { _decimalSeparator = ''; }
    let _nbDecimales = _decimalSeparator != '' ? this.recupererPartieDecimale(_format, _decimalSeparator).length : 0;
    return _nbDecimales
  }
}
